import * as amplitude from '@amplitude/analytics-browser';
import { isFeatureEnabled } from './utils';
import { FTR_KB_AMPLITUDE } from './Constants';

function getAmplitudeApiKey() {
    const reactAppEnv = process.env.REACT_APP_KB_ENV;
    const isBuddyEnv = process.env.REACT_APP_IS_BUDDY_ENV;
    if (reactAppEnv === 'dev' || isBuddyEnv === 'true') {
        return '';
    }
    return 'cc9fc57be55a0e6bbfcbd7271361f9bd';
}

const apiKey = getAmplitudeApiKey();

class Amplitude {
    constructor() {
        this._initialized = false;
        this._isFeatureEnabled = false;
    }

    init(availableFeatures = {}) {
        if (this._initialized || !apiKey) return;

        this._isFeatureEnabled = isFeatureEnabled(FTR_KB_AMPLITUDE, availableFeatures);
        if (!this._isFeatureEnabled) return;

        amplitude.init(apiKey, { defaultTracking: true });
        this._initialized = true;
    }

    track(eventName, properties = {}) {
        if (!this._initialized || !this._isFeatureEnabled) return;
        amplitude.track(eventName, properties);
    }
}

export const amplitudeTracker = new Amplitude();
